<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="car.client"
          [showClear]="true"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Гос. номер ТС</label>
        <crm-input-text
          [(value)]="car.carNumber"
          [isError]="$any(errors?.carNumber)"></crm-input-text>
        <small
          *ngIf="errors?.carNumber"
          class="p-error">
          {{ errors.carNumber | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Категория ТС</label>
        <crm-car-category-single-select
          [isError]="$any(errors?.category)"
          [(selectedCategory)]="car.category"
          appendTo="body">
        </crm-car-category-single-select>
        <small
          *ngIf="errors?.category"
          class="p-error">
          {{ errors.category | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Помещения</label>
        <crm-room-multi-select
          [isError]="$any(errors?.rooms)"
          [(selectedRooms)]="car.rooms"
          [isFloatLabel]="false"
          [onlyWithHikvisionCameras]="true"
          [autoSelectOne]="true"
          appendTo="body">
        </crm-room-multi-select>
        <small
          *ngIf="errors?.rooms"
          class="p-error">
          {{ errors.rooms | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveCar()"></button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <button
          *ngIf="!car['deleted']"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteCar()"></button>

        <button
          *ngIf="car['deleted']"
          pButton
          label="Восстановить"
          class="p-button-text"
          (click)="restoreCar()"></button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
